export default function createHumanVerification() {
  const state = {
    startedAt: Date.now(),
    interactions: 0,
    keyPresses: 0,
    focused: false,
  };

  const inc = () => state.interactions++;

  const init = () => {
    window.addEventListener("mousemove", inc);
    window.addEventListener("touchstart", inc);
    window.addEventListener("touchmove", inc);
    window.addEventListener("scroll", inc);
    window.addEventListener("click", inc);

    window.addEventListener("keydown", () => {
      state.keyPresses++;
    });

    window.addEventListener("focus", () => {
      state.focused = true;
    });
  };

  const destroy = () => {
    window.removeEventListener("mousemove", inc);
    window.removeEventListener("touchstart", inc);
    window.removeEventListener("touchmove", inc);
    window.removeEventListener("scroll", inc);
    window.removeEventListener("click", inc);
  };

  const executeHumanCheck = async (action) => {
    const getFingerprint = () => {
      return {
        ua: navigator.userAgent,
        screen: `${window.screen.width}x${window.screen.height}`,
        lang: navigator.language,
        platform: navigator.platform,
      };
    };

    const payload = {
      action,
      d: Date.now() - state.startedAt,
      i: state.interactions,
      k: state.keyPresses,
      f: state.focused ? 1 : 0,
      t: Date.now(),
      fp: getFingerprint(),
    };

    return btoa(JSON.stringify(payload));
  };

  return {
    init,
    destroy,
    executeHumanCheck,
  };
}
